import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../fragments/__generated__/PageInfo.generated';
import { WholesaleProductFragmentDoc } from '../../fragments/__generated__/WholesaleProduct.generated';
import { WholesaleProductElementFragmentDoc, WholesaleProductElementImageFragmentDoc } from '../../fragments/__generated__/WholesaleProductElement.generated';
import { ProductsDataFileFragmentDoc } from '../../fragments/__generated__/ProductsDataFile.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholesaleProductsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type WholesaleProductsQuery = { wholesaleProducts: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ node: { id: string, created: any, name: string, slug: string, sortOrder: number, description: any, rectangularImage: string | null, squareImage: string | null, elements: Array<{ id: string, name: string, slug: string, sortOrder: number, description: string, images: Array<{ id: string, image: string, sortOrder: number, width: number, height: number, thumbnail: string | null }> }>, category: { id: string, pk: number, name: string, slug: string, productsDataFile: { id: string, pk: number, created: any, resultFile: string | null } | null } | null } }> } };

export type WholesaleProductQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type WholesaleProductQuery = { wholesaleProduct: { id: string, created: any, name: string, slug: string, sortOrder: number, description: any, rectangularImage: string | null, squareImage: string | null, elements: Array<{ id: string, name: string, slug: string, sortOrder: number, description: string, images: Array<{ id: string, image: string, sortOrder: number, width: number, height: number, thumbnail: string | null }> }>, category: { id: string, pk: number, name: string, slug: string, productsDataFile: { id: string, pk: number, created: any, resultFile: string | null } | null } | null } | null };


export const WholesaleProductsDocument = gql`
    query WholesaleProducts($first: Int, $after: String) {
  wholesaleProducts(first: $first, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        ...WholesaleProductFragment
        elements {
          ...WholesaleProductElementFragment
          images {
            ...WholesaleProductElementImageFragment
          }
        }
        category {
          id
          pk
          name
          slug
          productsDataFile {
            ...ProductsDataFileFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${WholesaleProductFragmentDoc}
${WholesaleProductElementFragmentDoc}
${WholesaleProductElementImageFragmentDoc}
${ProductsDataFileFragmentDoc}`;

/**
 * __useWholesaleProductsQuery__
 *
 * To run a query within a React component, call `useWholesaleProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholesaleProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholesaleProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWholesaleProductsQuery(baseOptions?: Apollo.QueryHookOptions<WholesaleProductsQuery, WholesaleProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholesaleProductsQuery, WholesaleProductsQueryVariables>(WholesaleProductsDocument, options);
      }
export function useWholesaleProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholesaleProductsQuery, WholesaleProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholesaleProductsQuery, WholesaleProductsQueryVariables>(WholesaleProductsDocument, options);
        }
export type WholesaleProductsQueryHookResult = ReturnType<typeof useWholesaleProductsQuery>;
export type WholesaleProductsLazyQueryHookResult = ReturnType<typeof useWholesaleProductsLazyQuery>;
export type WholesaleProductsQueryResult = Apollo.QueryResult<WholesaleProductsQuery, WholesaleProductsQueryVariables>;
export function refetchWholesaleProductsQuery(variables?: WholesaleProductsQueryVariables) {
      return { query: WholesaleProductsDocument, variables: variables }
    }
export const WholesaleProductDocument = gql`
    query WholesaleProduct($slug: String!) {
  wholesaleProduct(slug: $slug) {
    ...WholesaleProductFragment
    elements {
      ...WholesaleProductElementFragment
      images {
        ...WholesaleProductElementImageFragment
      }
    }
    category {
      id
      pk
      name
      slug
      productsDataFile {
        ...ProductsDataFileFragment
      }
    }
  }
}
    ${WholesaleProductFragmentDoc}
${WholesaleProductElementFragmentDoc}
${WholesaleProductElementImageFragmentDoc}
${ProductsDataFileFragmentDoc}`;

/**
 * __useWholesaleProductQuery__
 *
 * To run a query within a React component, call `useWholesaleProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholesaleProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholesaleProductQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useWholesaleProductQuery(baseOptions: Apollo.QueryHookOptions<WholesaleProductQuery, WholesaleProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholesaleProductQuery, WholesaleProductQueryVariables>(WholesaleProductDocument, options);
      }
export function useWholesaleProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholesaleProductQuery, WholesaleProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholesaleProductQuery, WholesaleProductQueryVariables>(WholesaleProductDocument, options);
        }
export type WholesaleProductQueryHookResult = ReturnType<typeof useWholesaleProductQuery>;
export type WholesaleProductLazyQueryHookResult = ReturnType<typeof useWholesaleProductLazyQuery>;
export type WholesaleProductQueryResult = Apollo.QueryResult<WholesaleProductQuery, WholesaleProductQueryVariables>;
export function refetchWholesaleProductQuery(variables: WholesaleProductQueryVariables) {
      return { query: WholesaleProductDocument, variables: variables }
    }